export const SELECT_EVENT = "SELECT_EVENT";
export const CLEAR_SELECTED_EVENT = "CLEAR_SELECTED_EVENT";
